import React from 'react';
import { useNavigate } from 'react-router-dom';
import './TopicSelector.css';

export default function JuniorHighSpoken() {
  const navigate = useNavigate();

  return (
    <div className="topic-selector">
      <div className="topic-selector-container">
        <div className="header-with-back">
          <button onClick={() => navigate('/junior-high')} className="back-to-grade-button junior-high">
            חזרה לבחירת נושא
          </button>
          <h2 style={{ paddingTop: '20px' }}>שכבות ז׳-ט׳ - מדוברת</h2>
        </div>

        <p className="topic-selector-subtitle">בחרו מה לשחק</p>

        <div className="add-topic-info" style={{ marginTop: '20px' }}>
          <h4>מדוברת</h4>
          <p>בקרוב יתווספו כאן משחקים נוספים.</p>
        </div>
      </div>
    </div>
  );
}
